import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderStateService } from 'src/app/modules/order/services/order-state.service';

@Component({
  selector: 'app-payment-cancel',
  templateUrl: './payment-cancel.component.html',
  styleUrls: ['./payment-cancel.component.css']
})
export class PaymentCancelComponent implements OnInit {

  constructor(
    private activateRoute: ActivatedRoute,
    private router: Router,
    private orderStateService: OrderStateService,
  ) {
    this.orderStateService.guestOrderKey = activateRoute.snapshot.params.orderKey;
    this.router.navigateByUrl('payment/start');
  }

  ngOnInit(): void {
  }

}
